import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../constants/ActionTypes';
import { normalizeThirdPartyObject } from '../../components/pages/manage/apps/utils';
import { SAVE_LEVEL } from '../../constants/Level';

const StoreDefaults = {
    isLoading: false,
    isError: false,
    data: {
        chainCspConfiguration: {
            listOfDefaultDomains: [],
            listOfInContextHostDomains: []
        },
        hotelCspConfiguration: {
            listOfDefaultDomains: [],
            listOfInContextHostDomains: []
        },
        sojernTracking: {
            status: null
        },
        trivago: {
            status: null,
            advertiserId: '',
            channel: 'lpadv',
            advertiserIdIsInvalid: false
        },
        tripadvisor: {
            status: null
        },
        uplift: {
            status: null,
            disableForPartialDepositRates: false
        },
        thehotelnetwork: {
            status: null
        }
    },
    parentData: {
        chainCspConfiguration: {
            listOfDefaultDomains: [],
            listOfInContextHostDomains: []
        },
        hotelCspConfiguration: {
            listOfDefaultDomains: [],
            listOfInContextHostDomains: []
        },
        sojernTracking: {
            status: null
        },
        trivago: {
            status: null,
            advertiserId: '',
            channel: 'lpadv',
            advertiserIdIsInvalid: false
        },
        tripadvisor: {
            status: null
        },
        uplift: {
            status: null,
            disableForPartialDepositRates: false
        },
        thehotelnetwork: {
            status: null
        }
    },
    changedManageApps: false,
    isSojernChanged: false,
    isTHNChanged: false
};

const thirdpartyReducer = handleActions(
    {
        [ActionTypes.SET_LOCAL_CHANGES]: (state, action) => ({
            ...state,
            isLoading: false,
            isError: false,
            data: {
                ...state.data,
                ...action.data
            }
        }),
        [ActionTypes.START_THIRDPARTY_CONFIGURATION_FETCH]: state => ({
            ...state,
            isLoading: true,
            isError: false
        }),
        [ActionTypes.FINISH_THIRDPARTY_CONFIGURATION_FETCH]: state => ({
            ...state,
            isLoading: false,
            isError: false
        }),
        [ActionTypes.ERROR_THIRDPARTY_CONFIGURATION_FETCH]: state => ({
            ...state,
            isLoading: false,
            isError: true
        }),
        [ActionTypes.GET_THIRDPARTY_CONFIGURATION]: (state, action) => ({
            ...state,
            level: action.level,
            isLoading: false,
            isError: false,
            data: normalizeThirdPartyObject(action.level, action.data, StoreDefaults.data),
            parentData: normalizeThirdPartyObject(SAVE_LEVEL.CHAIN, action.parentData, StoreDefaults.parentData)
        }),
        [ActionTypes.GET_ALL_THIRDPARTY_CONFIGURATIONS]: state => ({
            ...state,
            isLoading: false,
            isError: false
        }),
        [ActionTypes.SAVE_THIRDPARTY_CONFIGURATION]: state => ({
            ...state,
            isLoading: false,
            isError: false
        }),
        [ActionTypes.SET_THIRDPARTY_APPS_DATA_IS_CHANGED]: (state, action) => ({
            ...state,
            changedManageApps: action.changedManageApps
        }),
        [ActionTypes.SET_THIRDPARTY_APPS_PARAMETERS]: (state, action) => ({
            ...state,
            ...action.state
        }),
        [ActionTypes.SET_SOJERN_STATUS_CHANGED]: (state, action) => ({
            ...state,
            isSojernChanged: action.isSojernChanged
        }),
        [ActionTypes.SET_THN_STATUS_CHANGED]: (state, action) => ({
            ...state,
            isTHNChanged: action.isTHNChanged
        })
    },
    StoreDefaults
);

export default thirdpartyReducer;



// WEBPACK FOOTER //
// ./src/reducers/manage/thirdparty.js